<template>
    <div style="overflow:hidden">
        <h1>Organization List</h1>
        <div class="messages">
            <div>
                <b-alert v-if="loading" variant="info" dismissible>Loading...</b-alert>
                <b-alert v-if="deletedItem" variant="info" dismissible @dismissed="dismissCountDown=0"
                         @dismiss-count-down="countDownChanged">{{ deletedItem['@id'] }} deleted.
                </b-alert>
                <b-alert v-if="error" variant="error" dismissible><span class="oi oi-warning" aria-hidden="true"></span>{{
                    error }}
                </b-alert>

            </div>
        </div>

        <div class="table-responsive">
            <b-table
                    striped hover
                    no-local-sorting
                    ref="table"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :per-page="perPage"
                    :current-page="currentPage"

                    :busy.sync="isBusy"
                    :items="itemsProvider"
                    :fields="fields"


            >


                <template slot="HEAD_email" slot-scope="data">
                    <em>{{data.label}}</em>
                    <b-form-input v-model="filter.email" @click.native.stop @click.stop placeholder="Type to Search" size="sm" />
                </template>
                <template slot="HEAD_ehotelierTextId" slot-scope="data">
                    <em>{{data.label}}</em>
                    <b-form-input v-model="filter.ehotelierTextId" @click.native.stop @click.stop placeholder="Type to Search" size="sm" />
                </template>
                <template slot="HEAD_url" slot-scope="data">
                    <em>{{data.label}}</em>
                    <b-form-input v-model="filter.url" @click.native.stop @click.stop placeholder="Type to Search" size="sm" />
                </template>
                <template slot="HEAD_addressCountry" slot-scope="data">
                    <em>{{data.label}}</em>
                    <b-form-input v-model="filter.addressCountry" @click.native.stop @click.stop placeholder="Type to Search" size="sm" />
                </template>
                <template slot="HEAD_addressRegion" slot-scope="data">
                    <em>{{data.label}}</em>
                    <b-form-input v-model="filter.addressRegion" @click.native.stop @click.stop placeholder="Type to Search" size="sm" />
                </template>
                <template slot="HEAD_postalCode" slot-scope="data">
                    <em>{{data.label}}</em>
                    <b-form-input v-model="filter.postalCode" @click.native.stop @click.stop placeholder="Type to Search" size="sm" />
                </template>
                <template slot="HEAD_doImport" slot-scope="data">
                    <em>{{data.label}}</em>
                    <b-form-input v-model="filter.doImport" @click.native.stop @click.stop placeholder="Type to Search" size="sm" />
                </template>





                <template slot="HEAD_id" slot-scope="data">
                    <em>{{data.label}}</em>
                    <b-form-input v-model="filter.id" @click.native.stop @click.stop placeholder="Type to Search" size="sm" />
                </template>


                <template slot="id" slot-scope="row">
                    <router-link :to="{name: 'OrganizationShow', params: { id: row.item['@id'] }}">{{
                        row.item['id'] }}
                    </router-link>
                </template>
                <template slot="actions" slot-scope="row">
                    <router-link :to="{name: 'OrganizationShow', params: { id: row.item['@id'] }}">
                        <span class="oi oi-magnifying-glass" aria-hidden="true"/>
                        <span class="sr-only">Show</span>
                    </router-link>
                    <router-link :to="{name: 'OrganizationUpdate', params: { id: row.item['@id'] }}">
                        <span class="oi oi-pencil" aria-hidden="true"/>
                        <span class="sr-only">Edit</span>
                    </router-link>
                </template>
            </b-table>

        </div>


        <footer class="footer fixed-bottom bn-footer">

      <span v-if="view" style="float:left">


          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pagination-sm" />
      </span>
            <div v-if="sortBy" class="bn-footerspan" style="margin-left:20px">
                Sorting By: <b>{{ sortBy }}</b>,
                Sort Direction: <b>{{ sortDesc ? 'Descending' : 'Ascending' }}</b>,
            </div>&nbsp;
            <div v-if="totalRows" class="bn-footerspan">
                &nbsp;Total Rows: <b>{{ totalRows }}</b>
            </div>
            <div style="float:right">
                <router-link :to="{ name: 'OrganizationCreate' }" class="btn btn-primary btn-sm">Create</router-link>
            </div>
        </footer>

    </div>
</template>
<style>

</style>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {Alert} from 'bootstrap-vue/es/components';
    import fetch from '../../utils/fetch';


    export default {
        computed: mapGetters({
            deletedItem: 'organization/del/deleted',
            error: 'organization/list/error',
            //items: 'organization/list/items',
            loading: 'organization/list/loading',
            view: 'organization/list/view'
        }),
        methods: mapActions({
            getPage: 'organization/list/getItems',
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            buildParameters: function () {
                let params = []
                if (this.sortBy) {
                    params.push('order[' + this.sortBy + ']=' + (this.sortDesc ? 'desc' : 'asc'));
                }
                if (this.currentPage){
                    params.push('page=' + this.currentPage);
                }
                if (this.filter){
                    for (let prop in this.filter){
                        if (this.filter.hasOwnProperty(prop)) {
                            if (typeof this.filter[prop] === 'object'){
                                let filterprop=this.filter[prop];

                                for (let fprop in filterprop){
                                    if (filterprop.hasOwnProperty(fprop) && filterprop[fprop]!=null) params.push(prop+'['+fprop+']='+filterprop[fprop]);
                                }

                            }else{
                                if(this.filter[prop]!='')params.push(prop+'='+this.filter[prop]);
                            }

                        }
                    }
                }

                return params
            },
            itemsProvider(e, ctx, callback) {
                ctx.currentPage=this.currentPage;
                ctx.totalRows=this.totalRows;
                ctx.filter=this.filter;
                this.$store.state.organization.list.ctx=ctx;
                this.sortBy = ctx.sortBy;
                this.sortDesc = ctx.sortDesc;

                fetch('/organizations?' + this.buildParameters().join('&'), {method: 'GET'})
                    .then(response => {

                        return response.json();
                    })
                    .then(data => {
                        this.totalRows=data['hydra:totalItems'];
                        callback(data['hydra:member']);
                    })
                    .catch(e => {
                        callback([]);
                    });


                return null;
            }
        }),
        components: {
            'alert': Alert
        },
        data: function () {
            return {
                dismissSecs: 5,
                dismissCountDown: 0,
                showDismissibleAlert: false,
                sortBy: this.$store.state.organization.list.ctx && this.$store.state.organization.list.ctx.sortBy ? this.$store.state.organization.list.ctx.sortBy : 'createdAt',
                sortDesc: this.$store.state.organization.list.ctx && this.$store.state.organization.list.ctx.sortDesc ? this.$store.state.organization.list.ctx.sortDesc : false,
                filter: this.$store.state.organization.list.ctx && this.$store.state.organization.list.ctx.filter ? this.$store.state.organization.list.ctx.filter : {'email':'', 'ehotelierTextId':'','url':'','addressCountry':'','addressRegion':'','postalCode':'','doImport':null,'createdAt':{'before':null,'strictly_before':null,'after':null,'strictly_after':null},'updatedAt':{'before':null,'strictly_before':null,'after':null,'strictly_after':null}},
                perPage: 30,
                isBusy: false,
                currentPage: this.$store.state.organization.list.ctx && this.$store.state.organization.list.ctx.currentPage ? this.$store.state.organization.list.ctx.currentPage : 1,
                totalRows: this.$store.state.organization.list.ctx && this.$store.state.organization.list.ctx.totalRows ? this.$store.state.organization.list.ctx.totalRows : 0,
                fields: [
                    {key: 'id', sortable: false},
                    {key: 'ehotelierTextId', sortable: true},
                    {key: 'doImport', sortable: true},
                    {key: 'translations.de.legalName', label: 'Legal Name', sortable: false},
                    {key: 'email', sortable: true},
                    {key: 'url', sortable: true},
                    {key: 'telephone', sortable: false},
                    {key: 'addressCountry', sortable: true},
                    {key: 'addressLocality', sortable: true},
                    {key: 'addressRegion', sortable: true},
                    {key: 'postalCode', sortable: true},
                    {key: 'createdAt', sortable: true},
                    {key: 'updatedAt', sortable: true},
                    {key: 'actions', label: 'Actions'}
                ],
            }
        },
        created() {
            this.$store.dispatch('organization/list/getItems')
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/organization/List.vue